import React, { useState } from 'react';
import Styled from 'styled-components';
import { Layout, Menu, Switch } from 'antd';

const { Content } = Layout;
import { BlockLayout } from '../layouts';
import TaxReturn_1 from './TaxReturn_1';
import TaxReturn_2 from './TaxReturn_2';
import TaxReturn_3 from './TaxReturn_3';
import TaxReturn_4 from './TaxReturn_4';

const menuItems = [
  { key: '1', label: 'Profit & Loss' },
  { key: '2', label: 'Annexes' },
  { key: '3', label: 'Assets' },
  { key: '4', label: 'Balance Sheet' }
];

const StyledMenu = Styled(Menu)`
  border: none;
  line-height: 2;
`;

const TaxReturn = () => {
  const [section, setSection] = useState('1');
  const [isEnglish, setIsEnglish] = useState(false);

	return (
    <>
    <BlockLayout style={{ margin: 0 }}>
      <Content>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <StyledMenu mode='horizontal' defaultSelectedKeys={section} items={menuItems}
            onClick={e => setSection(e.key)} />
          <Switch checkedChildren="EN" unCheckedChildren="JP"
            onChange={check => setIsEnglish(check)} />
        </div>

        {section === '1' && <TaxReturn_1 isEnglish={isEnglish} />}
        {section === '2' && <TaxReturn_2 isEnglish={isEnglish} />}
        {section === '3' && <TaxReturn_3 isEnglish={isEnglish} />}
        {section === '4' && <TaxReturn_4 isEnglish={isEnglish} />}
      </Content>
    </BlockLayout>
    </>
	);

};

export default TaxReturn;